import React from "react";
import "./formRegistry.css";

const normalizeFormName = (formName = "") => {
    return String(formName)
        .trim()
        .replace(/[^a-zA-Z0-9]+/g, "")
        .toLowerCase();
};

const buildFormComponentMap = () => {
    const formModules = require.context("../Forms", false, /\.js$/);

    return formModules.keys().reduce((acc, modulePath) => {
        const componentName = modulePath.replace(/^\.\/(.*)\.js$/, "$1");

        const componentModule = formModules(modulePath);
        const component =
            componentModule?.default || componentModule;

        if (component && componentName !== "formRegistry") {
            acc[normalizeFormName(componentName)] = component;
        }

        return acc;
    }, {});
};

let formComponentMap = null;

export function resolveFormComponent(formName) {
    if (!formName) return null;

    if (!formComponentMap) {
        formComponentMap = buildFormComponentMap();
    }

    const normalized = normalizeFormName(formName);

    return formComponentMap[normalized] || null;
}

export function renderFormComponent(
    formName,
    fallbackLabel = "Unknown"
) {
    const Component = resolveFormComponent(formName);

    if (Component) {
        return <Component />;
    }

    return (
        <section className="page_404">
            <div className="container_404">
                <div className="row_404">
                    <div className="error_wrapper">
                        <div className="error_content">

                            <div className="four_zero_four_bg">
                                <h1>404</h1>
                            </div>

                            <div className="contant_box_404">
                                <h3 className="error_title">
                                    Look like you're lost
                                </h3>

                                <p className="error_message">
                                    The page you are looking for is not
                                    available!
                                </p>

                                {formName && (
                                    <p className="error_form_name">
                                        Requested page:{" "}
                                        <strong>{formName}</strong>
                                    </p>
                                )}

                                <a
                                    href="/"
                                    className="link_404"
                                >
                                    Go to Home
                                </a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}